/**
 * API - POSTS
 * https://bitbucket.org/interlective/bridgealliance_react_frontend
 */

//Search Post
async function searchPosts(token,page,formdata) {      
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/getposts?page=${page}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify(formdata)
    });    
  }

  //Search Post News
async function searchPostNews(token,page,formdata) {   
  return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/getposts_news?page=${page}`, {
    timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(formdata)
  }); 
}

  async function searchOffering(token,slug,env) {
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/get-offering?slug=${slug}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify({"env":env})
    });
  }
  async function searchResource(token,slug,env) {
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/get-resource?slug=${slug}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify({"env":env})
    });
  }

  async function searchNews(token,slug,env) {

    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/get-news?slug=${slug}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({"env":env})
    });

    /*
    if(token== "")
    {
      token =  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvc2VhLXBpbG90LmJyaWRnZWFsbGlhbmNlLmNvbSIsImlhdCI6MTY5Mzk3NDQ5MiwibmJmIjoxNjkzOTc0NDkyLCJleHAiOjE2OTQwNjA4OTIsImRhdGEiOnsidXNlciI6eyJpZCI6IjE0NSJ9fX0.BYnnD69NmzZEufoYpJCjr2cG8QDXCkSda6fM-vk9ku4"
    }
    
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/get-news?slug=${slug}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify({"env":env})
    });
    */
  }

  //Videos
  async function searchVideos(token,slug,env) {
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/get-videos?slug=${slug}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify({"env":env})
    });
  }

  //SalesKits
  async function searchSalesKits(token,slug,env) {
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/get-saleskits?slug=${slug}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify({"env":env})
    });
  }
  //SalesKits

export default {
    searchPosts,
    searchPostNews,
    searchOffering,
    searchResource,
    searchNews,
    searchVideos,
    searchSalesKits
}